import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} fill="none" ref={ref} {...props}>
    <g>
      <path
        fill="#fff"
        stroke="#383838"
        d="M12.606 14.791a1.1 1.1 0 0 0 1.007-1.01c.117-1.821.179-3.595.179-5.62 0-2.023-.062-3.797-.179-5.617a1.1 1.1 0 0 0-1.007-1.012 45.15 45.15 0 0 0-9.057 0 1.1 1.1 0 0 0-1.007 1.012 85.51 85.51 0 0 0-.179 5.618c0 2.024.062 3.798.179 5.618a1.1 1.1 0 0 0 1.007 1.011c3.149.304 5.908.304 9.057 0Z"
      />
      <path
        fill="#383838"
        d="M5.293 5.302a.5.5 0 0 0 1 0h-1Zm1-.572a.5.5 0 0 0-1 0h1Zm1.286.572a.5.5 0 0 0 1 0h-1Zm1-.572a.5.5 0 0 0-1 0h1Zm1.285.572a.5.5 0 0 0 1 0h-1Zm1-.572a.5.5 0 0 0-1 0h1Zm-5.571 4a.5.5 0 0 0 1 0h-1Zm1-.57a.5.5 0 0 0-1 0h1Zm1.286.57a.5.5 0 0 0 1 0h-1Zm1-.57a.5.5 0 0 0-1 0h1Zm1.285.57a.5.5 0 0 0 1 0h-1Zm1-.57a.5.5 0 0 0-1 0h1Zm-4.571 6.856v-2.928h-1v2.928h1Zm0-2.928h3.571v-1H6.293v1Zm3.571 0v2.928h1v-2.928h-1Zm0 0h1a1 1 0 0 0-1-1v1Zm-3.571 0v-1a1 1 0 0 0-1 1h1Zm0-6.786V4.73h-1v.572h1Zm2.286 0V4.73h-1v.572h1Zm2.285 0V4.73h-1v.572h1ZM6.293 8.73v-.57h-1v.57h1Zm2.286 0v-.57h-1v.57h1Zm2.285 0v-.57h-1v.57h1Z"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const IconBuilding = memo(ForwardRef);
export default IconBuilding;
